export default __webpack_public_path__ + "static/media/infoamazonia_map.10d85453.svg";